import { CloseButton, Dialog, Portal } from "@chakra-ui/react";

type ModalProps = {
  isOpen?: boolean;
  setIsOpen?: (isOpen: boolean) => void;
  title: React.ReactNode;
  content: React.ReactNode;
  footer?: React.ReactNode;
  maxWidth?: number | string;
};

export const Modal = ({ isOpen, setIsOpen, title, content, footer, maxWidth }: ModalProps) => {
  return (
    <Dialog.Root placement="center" open={isOpen} onOpenChange={e => setIsOpen?.(e.open)}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content maxW={maxWidth}>
            <Dialog.Header paddingBottom={1}>
              <Dialog.Title fontWeight={700}>{title}</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>{content}</Dialog.Body>
            {footer && <Dialog.Footer>{footer}</Dialog.Footer>}
            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
